import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Strings from 'localization/Strings';
import Accordion from 'react-bootstrap/Accordion';
import InnerSeverityOfHearing from './InnerSeverityOfHearing'
import InnerStatisticalModel from './InnerStatisticalModel';
import InnerPostOperativeRankings from './InnerPostOperativeRankings'
import InnerFunctionalOutcomes from './InnerFunctionalOutcomes';
import InnerReferences from './InnerReferences';
import MoreInfoTables, {requests, tables} from './Tables/MoreInfoTables';
import { Version } from 'Version';

class StatModelMoreInfo extends Component {

    HowCochlearImplantsWork(){
        return (
        <div>
            <p>
                Cochlear implants replace the function of damaged sensory hair cells inside the inner ear.
            </p>
            <p>
                Unlike hearing aids, which mostly make sounds louder, cochlear implants may further improve the clarity of sound and enhance your ability to understand conversations [1,2,3, 14-19].
            </p>
            <p>
                A cochlear implant system has two parts:
            </p>
            <ul>
                <li>the external sound processor</li>
                <li>surgeons put the implant under the skin and attach it to an electrode array that’s placed in the inner ear</li>
            </ul>
            <p>
                Together, the sound processor and implant bypass the part of the ear that isn’t working, sending sound straight to the hearing nerve.        
            </p>
            <iframe className='mt30' width="840" height="473" src="https://www.youtube.com/embed/YdYjdYD--nk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
        </div>    
        );
    }
    HowToUse() {
        return (
        <div>
            <p>
                The Referral Support Tool is a clinical aid for audiologists to discuss cochlear implantation as an option to treat hearing loss and promote the referral of suitable patients for further evaluation by specialists at a cochlear implant clinic.
            </p>
            <p>
                    The audiologist selects from options that best represent the client such as age range, severity of hearing loss, and four Speech Spatial Qualities (SSQ-49) questionnaire relating to the clarity of sound or how much effort is required for conversation.
            </p>
            <p>
                The tool uses the persona input and produces an output showing an estimation of a starting binaural aided speech word score test (consonant-nucleus-consonant (CNC) speech discrimination test) and a range of possible binaural hearing performance at one year after implantation. The tool also compares the pre-implantation implantation ratings entered by the user for the four SSQ-49 questions against the proportion of the cochlear implant recipients rating themselves as higher one year post implantation.
            </p>
            <p>
                The audiologist can then use their expertise and this information to counsel the client.
            </p>
            </div>
        );
    }
    Assumptions() {
        return (
            <div>
                <p>
                    The assumptions and limitations of the tool are as follows:
                </p>
                <ul className="moreinfo-ul">
                    <li>The tool is not designed for making diagnoses or prescribing treatment and this tool does not evaluate or compare all hearing treatment options</li>
                    <li>The tool is designed for a single ear under consideration for treatment and it is further assumed that postoperatively the cochlear implant on ipsilateral ear will be used in conjunction with hearing amplification on the contralateral ear</li>
                    <li>The tool is not designed for considering treatment of Single Sided Deafness (SSD)</li>
                    <li>The clients are post-lingually deafened adults</li>
                    <li>The hearing loss that the clients experience is of general age-related hearing loss or sensory-neural hearing loss with a high frequency roll-off</li>
                    <li>The client does not have significant comorbidities that contribute to their severity of hearing loss and level of speech comprehension</li>
                    <li>The preoperative or postoperative hearing performance being considered are that of the binaural aided treatment scenario (ie. left side or right side, not in conjunction)</li>
                    <li>After cochlear implant switch-on the client will use their implant 12 hrs/day on average</li>
                    <li>The binaural aided CNC speech discrimination test is conducted under the circumstance of both ears having hearing amplified or electrically induced by a cochlear implant</li>
                </ul>
            </div>);
    }
    ReferralGuidelines(){
        return (
            <div>
                <p>
                    The following links contains information on cochlear implantation candidacy criteria and warnings:
                </p>
                <ul className="moreinfo-ul">
                    <li> <a href='https://assets.boystown.org/hosp_peds_docs/Guidelines%20for%20Cochlear%20Implant%20Referral.pdf'>Cochlear Implant Referral Guidelines</a></li>
                    <li> <a href='https://www.cochlear.com/us/en/professionals/products-and-candidacy/candidacy/cochlear-implant'>Cochlear implant candidacy criteria | Adults and children</a></li>
                    <li> <a href='https://www.fda.gov/medical-devices/implants-and-prosthetics/cochlear-implants'>Cochlear Implants | FDA</a></li >
                    <li> <a href='https://www.cochlear.com/us/en/corporate/global-warnings'>Global Warning and Precautions per Region for Cochlear Implants</a></li>
                </ul>
            </div>);
    }
    ComponentsOfTheReferralSupportTool() {
        return (
            <div>
                <p>
                    The Referral Support Tool is comprised by several key components:
                </p>
                <ul className="moreinfo-ul">
                    <li className='pl50'>Severity of hearing loss categories [4]</li>
                    <li>A statistical model that estimates the inpostoperative binaural aided CNC speech discrimination sore and corresponding range (90% Prediction Interval) one year after implantation [5]</li>
                    <li>Comparison of the ratings that the audiologist entered in for the four SSQ questions and postoperative (one year after implantation) cochlear implant recipient rating distributionsPostoperative [6]</li>
                </ul>

            </div>);
    }
    SolicitedInformationAndPrivacy() {
        return (
            <div>
                <p>
                    The Referral Support Tool prompts the audiologist to select information that best represents their client. This information is partially used as an input into the statistical model which estimates the postoperative (one year after implantation) binaural aided CNC speech discrimination score. The following list contains the types of the information solicited and the options that the audiologist can select:
                </p>
                <ul className="moreinfo-ul">
                    <li>
                        Age range
                        <ul className="moreinfo-ul">
                            <li>&lt; 50; 50 to 60; 60 to 70; 70 to 80; and 80+</li>
                        </ul>
                    </li>
                    <li>
                        Severity of hearing loss
                        <ul className="moreinfo-ul">
                            <li>Moderate (40 to 60): Pure Tone Average (dBHL): 40 to 60</li>
                            <li>Severe (60 to 80): Pure Tone Average (dBHL): 60 to 80</li>
                            <li>Severe to profound (80 to 90): Pure Tone Average (dBHL): 80 to 90</li>
                            <li>Profound (90 to 100): Pure Tone Average (dBHL): 90 to 100</li>
                            <li>Profound (100+): Pure Tone Average (dBHL): 100+</li>
                        </ul>
                    </li>
                    <li>
                    	SSQ-49 question S1Q2 - You are talking with one other person in a quiet, carpeted loungeroom. Can you follow what the other person says?
                        <ul className="moreinfo-ul">
                            <li>Range: 0 to 10</li>
                            <li>Value 0: ‘Not at all’</li>
                            <li>Value 10: ‘Perfectly’</li>
                        </ul>
                    </li>
                    <li>
                        SSQ-49 question S1Q13 - Can you easily have a conversation on the telephone?
                        <ul className="moreinfo-ul">
                            <li>Range: 0 to 10</li>
                        	<li>Value 0: ‘Not at all’</li>
                        	<li>Value 10: ‘Perfectly’</li>
                        </ul>
                    </li>
                    <li>
                        SSQ-49 question S3Q10 – Do other people’s voices sound clear and natural?
                        <ul className="moreinfo-ul">
                            <li>Range: 0 to 10</li>
                            <li>Value 0: ‘Not at all’</li>
                            <li>Value 10: ‘Perfectly’</li>
                        </ul>
                    </li>
                    <li>
                        SSQ-49 question S3Q15 – Do you have to put in a lot of effort to hear what is being said in conversation with others?
                        <ul className="moreinfo-ul">
                            <li>Range: 0 to 10</li>
                            <li>Value 0: ‘Lots of effort’</li>
                            <li>Value 10: ‘No effort’</li>
                        </ul>
                    </li>                        
                </ul>
                <p>
                    The information solicited by the tool remains on the user’s or audiologist’s computer and is not transmitted elsewhere or retained. The information inputted is coarse and is not able to be used to link back to the client.
                </p>
            </div>);
    }
    Evidence() {
        return (
            <div>
                <p>
                    This tool was developed using best evidence from large high quality clinical datasets. The combined clinical datasets comprise data of approximately 1913 subjects. The constituent datasets are:
                </p>
                <ul className="moreinfo-ul">
                    <li>Retrospective Study: A large multi-clinic dataset (CAM5717) of which data was collected through the clinics’ routine clinical practice (contributing 1282 subjects) [7]</li>
                    <li>Clinical Studies: Two clinical studies (CLTD5685 and CLTD5595) that collected preoperative patient characteristics as well as postoperative hearing performance metrics (contributing 219 subjects) [8,9]</li>
                    <li>Registry: Cochlear implantation registry (CEL5277) that collected preoperative and postoperative subject quality of life information (contributing 412 subjects) [10]</li>
                </ul>
                <p>
                    The clinical datasets were used in the following ways:
                </p>                
                <ul className="moreinfo-ul">
                    <li>The Retrospective Study was used to derive severity of hearing loss categories</li>
                    <li>The Clinical Studies were used to develop the statistical model that estimates statesthe postoperative (one year after implantation) binaural aided CNC word score and corresponding range of likely scores (90% prediction interval)</li>
                    <li>The Clinical Studies and the Registry were used to estimate of the proportion of cochlear implant recipients rating themselves as performing better postoperatively (one year after implantation) than the corresponding preoperative ratings entered by the audiologist for the four SSQ-49 questions (S1Q2, S1Q13, S3Q10 and S3Q15)</li>
                </ul>
                <p>
                    Table <MoreInfoTables table={tables.Demography} request={requests.Index} /> records the general demographics of the subjects that were used in the development of the Referral Support Tool.
                </p> 
                <MoreInfoTables table={tables.Demography} request={requests.Title} />
                <MoreInfoTables table={tables.Demography} request={requests.Table} />
            </div>);
    }
    SeverityOfHearingLossCategories() {
        return (<InnerSeverityOfHearing />);
    }
    StatisticalModel() {
        return (<InnerStatisticalModel />);
    }
    PostoperativeRankings() {
        return (<InnerPostOperativeRankings />);
    }
    FunctionalOutcomes() {
        return (<InnerFunctionalOutcomes />);
    }
    References() {
        return (<InnerReferences />);
    }


    render () {
        return (
            <div className="component-card-content">
                <h1 className="more-info-title">{Strings.strings.StatModelMoreInfo.Title}
                    <span className='version'>
                        (version {Version})
                    </span>
                </h1>

                <Accordion className='pb70'>
                <Accordion.Item eventKey="0">
                        <Accordion.Header>How cochlear implants work</Accordion.Header>
                        <Accordion.Body>{this.HowCochlearImplantsWork()}</Accordion.Body>
                    </Accordion.Item>                    
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>How to use</Accordion.Header>
                        <Accordion.Body>{this.HowToUse()}</Accordion.Body>
                    </Accordion.Item>    
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Assumptions</Accordion.Header>
                        <Accordion.Body>{this.Assumptions()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Cochlear implantation referral guidelines, candidacy criteria and warnings</Accordion.Header>
                        <Accordion.Body>{this.ReferralGuidelines()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Components of the Referral Support Tool</Accordion.Header>
                        <Accordion.Body>{this.ComponentsOfTheReferralSupportTool()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Solicited information and privacy</Accordion.Header>
                        <Accordion.Body>{this.SolicitedInformationAndPrivacy()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Evidence</Accordion.Header>
                        <Accordion.Body>{this.Evidence()}</Accordion.Body> 
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="7">
                        <Accordion.Header>Severity of hearing loss categories</Accordion.Header>
                        <Accordion.Body>{this.SeverityOfHearingLossCategories()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="8">
                        <Accordion.Header>Statistical model</Accordion.Header>
                        <Accordion.Body>{this.StatisticalModel()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="9">
                        <Accordion.Header>Postoperative rankings</Accordion.Header>
                        <Accordion.Body>{this.PostoperativeRankings()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="10">
                        <Accordion.Header>Functional outcomes</Accordion.Header>
                        <Accordion.Body>{this.FunctionalOutcomes()}</Accordion.Body>
                    </Accordion.Item>                                        
                    <Accordion.Item eventKey="11">
                        <Accordion.Header>References</Accordion.Header>
                        <Accordion.Body>{this.References()}</Accordion.Body>
                    </Accordion.Item>                                        
                </Accordion>
            </div>
        );
    }
}

export default StatModelMoreInfo;